import { render, staticRenderFns } from "./FooterDesktopComponent.vue?vue&type=template&id=00306a3d"
import script from "./FooterDesktopComponent.vue?vue&type=script&lang=js"
export * from "./FooterDesktopComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports